export const ISalesType = {
  id: 1,
  name: 'In-Store',
  icon: '',
  is_archive: false,
  store_id: 0,
  is_active: true,
  availability_id: 1,
  has_preorder: false,
  has_same_day_preorder: false,
  has_following_days_preorder: false,
  preorder_min_minutes: 6,
  preorder_max_minutes: 7,
  preorder_min_days: 8,
  preorder_max_days: 9,
}

export const IUnit = {
  id: 1,
  name: 'Item',
  name_plural_1: 'Items',
  name_plural_2: '',
  name_plural_3: '',
  name_plural_4: '',
  name_plural_5: '',
  is_active: true,
  is_archive: false,
  last_user_id: 0,
  created_at: '2023-10-06T09:52:22.818Z',
  updated_at: '2023-10-06T09:52:22.818Z',
  archived_at: null,
}

export const IItemType = {
  id: 1,
  name: 'item Type1',
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-10-25T14:46:40.612Z',
  updated_at: '2023-10-25T14:46:40.612Z',
  archived_at: null,
}

export const ITag = {
  id: 1,
  name: 'Tag 1',
  colour: '#AEAEAE',
  is_archive: false,
  last_user_id: 32,
  created_at: '2023-10-18T15:25:45.027Z',
  updated_at: '2023-10-18T15:25:45.027Z',
  archived_at: null,
}

export const IInventoryLocation = {
  id: 3,
  store_id: 56,
  name: 'category 1',
  last_user_id: 32,
  created_at: '2023-10-10T18:39:43.816Z',
  updated_at: '2023-10-10T18:39:43.816Z',
  is_archive: false,
  archived_at: null,
}

export const IConfig = {
  category_name: 'Inventory',
  logo: 'https://1000logos.net/wp-content/uploads/2016/10/Apple-Logo.png',
  items: [
    {
      id: 1,
      access: 'add/edit item',
      description: 'this is add / edit items',
    },
  ],
}

export const IStaffRole = {
  id: 1,
  name: 'Role 1',
  access: [1, 2, 3],
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-11-27T12:14:21.078Z',
  updated_at: '2023-11-27T12:17:47.011Z',
  archived_at: '2023-11-27T12:16:50.410Z',
}

export const ICustomerGroup = {
  id: 2,
  name: 'VIP 2',
  is_archive: true,
  last_user_id: 15,
  created_at: '2023-12-30T20:32:08.032Z',
  updated_at: '2023-12-30T20:33:36.047Z',
  archived_at: '2023-12-30T20:33:36.047Z',
}

export const ITemplate = {
  id: 126,
  name: 'Template 1',
  size: 'receipt',
  type: 'receipt',
  items: [],
}
